import React from 'react';
import { Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { secondaryBlue } from '../../../../utils/color';
import { ReactComponent as FlagIcon } from '../../../../assets/icons/chat-icons/flag-fill.svg';
import { ReactComponent as LinkIcon } from '../../../../assets/icons/chat-icons/link.svg';
import Link from '../../../../components/link/Link';
import FramedIcon from '../../FramedIcon';
import { formatDateFns } from '../../../../utils/helpers';

type MilestoneFlagSpecialProps = {
  entity: string;
  created: string;
  flaggedBy: string;
  link: string;
};

export default ({ entity, created, link, flaggedBy }: MilestoneFlagSpecialProps) => {
  const { t, i18n } = useTranslation();
  return (
    <Stack gap={3} alignItems="flex-start">
      <Link to={link} target="_blank">
        <Stack alignItems="center" gap={3}>
          <Stack direction="row" alignItems="center" gap={3}>
            <Stack direction="row" alignItems="center" gap={1.5}>
              <FramedIcon Icon={FlagIcon} variant="pink" />
              <Typography variant="heading4" color="primaryDark.600">
                {entity} {t('common.flagged')}
              </Typography>
            </Stack>
            <LinkIcon fill={secondaryBlue[700]} style={{ width: 16, height: 16 }} />
          </Stack>
        </Stack>
      </Link>
      <Stack direction="row" gap={3}>
        <Stack>
          <Typography variant="heading5" color="primaryDark.400">
            {t('common.date')}
          </Typography>
          <Typography variant="bodyMedium3" color="primaryDark.600">
            {formatDateFns(new Date(created), i18n.language, '', 'PPPP')}
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="heading5" color="primaryDark.400">
            {t('common.flaggedBy')}
          </Typography>
          <Typography variant="bodyMedium3" color="primaryDark.600">
            {flaggedBy}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
